import axios from "axios";
import { store } from "../app/store";
import { logout } from "../app/features/authSlice";
import apiDomainService from "./apiDomainService";

// Fetch the base URL via the domain service just like Angular
const BASE_URL = apiDomainService.replaceSubdomain();

const apiClient = axios.create({
  baseURL: BASE_URL,
});

// 🔹 REQUEST INTERCEPTOR
apiClient.interceptors.request.use((config) => {
  const state = store.getState();
  const token = state.auth.token;

  if (!config.headers) {
    config.headers = {};
  }

  // Check if we should use Bearer token (based on custom header prop)
  if (config.headers['X-Use-Bearer'] && token) {
    delete config.headers['X-Use-Bearer'];
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    // Default Basic Auth fallback
    const userName = 'sa';
    const password = 'Tenant@123';
    const authHeader = 'Basic ' + btoa(`${userName}:${password}`);
    config.headers.Authorization = authHeader;
  }

  return config;
}, (error) => {
  return Promise.reject(error);
});

apiClient.interceptors.response.use(
  (res) => res,
  async (error) => {
    const status = error.response?.status;
    if (status === 401) {
      store.dispatch(logout());
    }
    return Promise.reject(error);
  }
);

export default apiClient;
